import {
  defaultDurationInMinutes,
  durationsInMinutes,
  bookRoomDurationsInMinutes,
  roomAvailabilityPeriodOfInterest,
} from './defaultMeetingConfig';
import {MeetingsUiState, NewMeeting} from './types';

export const getNewMeetingInitialState = (): NewMeeting => ({
  title: '',
  message: '',
  attendees: [],
  isOnlineMeeting: true,
  isAllDay: false,
  selectedEndDateTime: '',
  selectedStartDateTime: '',
  roomIds: [],
});

export const getInitialState = (): MeetingsUiState => ({
  newMeeting: getNewMeetingInitialState(),
  meetingDurations: durationsInMinutes,
  bookRoomNowDurations: bookRoomDurationsInMinutes,
  defaultMeetingDuration: defaultDurationInMinutes,
  newMeetingBuildingId: '',
  roomAvailabilityPeriodOfInterest,
});
